import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  TextFieldProps,
  IconButton,
} from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';

type SearchBarBoxProps = {
  searchTerm: string;
  onChange: (value: string) => void;
  clear?: () => void;
  setIsModalOpen?: () => void;
  placeholder?: string;
  width?: number | string;
  size?: TextFieldProps['size'];
  autofocus?: boolean;
};

const SearchBarBox: React.FC<SearchBarBoxProps> = ({
  searchTerm,
  onChange,
  clear,
  placeholder = 'Search',
  width = 300,
  size = 'small',
  autofocus = false,
}) => {
  return (
    <Box
      data-testid="search-bar-box"
      display="flex"
      alignItems="center"
      width={width}
    >
      <TextField
        variant="outlined"
        placeholder={placeholder}
        size={size}
        fullWidth
        value={searchTerm}
        onChange={e => {
          onChange(e.target.value);
        }}
        autoFocus={autofocus}
        InputProps={{
          inputProps: { 'aria-label': 'search' },
          style: { backgroundColor: 'white', height: 32, fontSize: 13 },
          startAdornment: (
            <InputAdornment position="start">
              <Search color="primary" />
            </InputAdornment>
          ),
          endAdornment: clear ? (
            <IconButton onClick={clear}>
              <InputAdornment position="end">
                <Close color="disabled" fontSize="small" />
              </InputAdornment>
            </IconButton>
          ) : null,
        }}
      />
    </Box>
  );
};

export default SearchBarBox;
